@if (getUiActionButtonState$ | async; as data) {
    @if (data.selectedPaymentMethod === paymentMethod.ApplePayDirect) {
        <button
            class="applePayButton apple-pay-button apple-pay-button-black w-100"
            [disabled]="data.button.isDisabled && !data.button.isProcessing"
            (click)="onButtonClick(data.button.state)"></button>
    } @else {
        <div class="quick-bet-action-button-container" [ngClass]="{ 'placeholder action-button': data.button === undefined }">
            @if (data.button) {
                <button
                    ds-button
                    msThemedButton
                    variant="filled"
                    size="large"
                    wrapText="true"
                    class="quick-bet-place-bet-button"
                    [kind]="getButtonKind(data.button.state)"
                    [themeKind]="getButtonThemeKind()"
                    [loading]="data.button.isProcessing"
                    [disabled]="data.button.isDisabled && !data.button.isProcessing"
                    (click)="onButtonClick(data.button.state)">
                    {{ getButtonTitle(data.button.state) }}
                    @if (showStake(data.button.state)) {
                        {{ getStake(data.quickBet, data.isEachWay, data.selectedToken) }}
                    }
                    @if (getButtonMessage(data.quickBet, data.button, data.closedPickCount, data.lockedPickCount)) {
                        <span slot="subtext">{{ getButtonMessage(data.quickBet, data.button, data.closedPickCount, data.lockedPickCount) }}</span>
                    }
                    @if (data.button.state !== buttonStates.AcceptChanges && !quickBetConfig.isTotalReturnsEnabled && !epcotEnabled) {
                        {{ getPossibleWinningsLabel(data.button) }} {{ getPossibleWinnings(data.button) | bsCurrency: true }}
                    }
                    <ng-template #loadingTemplate>
                        <span class="quick-bet-place-button__loading"></span> {{ getButtonTitle(data.button.state) }}
                        @if (showStake(data.button.state) && !epcotEnabled) {
                            {{ getStake(data.quickBet, data.isEachWay, data.selectedToken) }}
                        }
                    </ng-template>
                </button>
                @if (data.button.state !== buttonStates.AcceptChanges && !quickBetConfig.isTotalReturnsEnabled && epcotEnabled) {
                    <div class="quick-bet-action-button__possible-winnings epcot">
                        <span class="quick-bet-action-button__possible-winnings-label">{{ getPossibleWinningsLabel(data.button) }}</span>
                        <span class="quick-bet-action-button__possible-winnings-value">
                            {{ getPossibleWinnings(data.button) | bsCurrency: true }}
                        </span>
                        <bs-betslip-taxation-liability [taxBackGiven]="getTaxationLiability(data.quickBet)"></bs-betslip-taxation-liability>
                    </div>
                }
            }
        </div>
    }
}
